import(/* webpackMode: "eager", webpackExports: ["DocumentationPageContent"] */ "/vercel/path0/src/components/inbound-gpt/documentation-page.tsx");
